export const constants = {
  MODULE_NAME: "maintenance",
};
